import { createContext } from 'react';

export const TakeTourContext = createContext();
